module.exports = __webpack_public_path__ + "static/media/feb1120192.fddf9f47.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feb1120192.jpeg
// module id = 1681
// module chunks = 0